import { DrawerBody, DrawerHeader, Flex, Avatar, Text, Link, Heading, Badge } from '@chakra-ui/react'
import { useMapCoreManager } from '../../../../contexts/MapCoreManager/Provider'
import { CITIZEN_PROFILE_EXTERNAL_ROUTES } from 'modules/CitizenProfile/constants/routes'
import { useMemo } from 'react'
import { getAfaCodeFormat } from 'modules/Geo/utils/afacode/getAfaCodeFormat'
import { cpfMask } from 'utils/masks'

export default function AddressDrawer() {
  const { selectedEntity } = useMapCoreManager()

  if (!selectedEntity) return <></>

  const data = selectedEntity?.data

  console.log('data: ', data)

  return (
    <>
      <DrawerHeader>Endereço</DrawerHeader>
      <DrawerBody p={0}>
        <Flex
          bg="bgContent"
          alignItems={'center'}
          justifyContent={'center'}
          borderBottom={'1px solid'}
          borderColor={'borderColor'}
          h="100px"
        >
          <Heading size={'2xl'}>{getAfaCodeFormat(data?.afacode)}</Heading>
        </Flex>
        <Flex
          p={4}
          gap={2}
          bg="bgContent"
          w="full"
          borderBottom={'1px solid'}
          borderColor="borderColor"
          flexDir={'column'}
        >
          <DetailItem label="Rua" value={data?.street} />
          <DetailItem label="Bairro" value={data?.neighbourhood} />
          <DetailItem label="Número" value={data?.number} />
          {data?.condominium && <DetailItem label="Condomínio" value={data?.condominium} />}
          {data?.block && <DetailItem label="Bloco" value={data?.block} />}
          {data?.apartment && <DetailItem label="Apartamento" value={data?.apartment} />}
          <DetailItem label="CEP" value={data?.zip_code} />
          <DetailItem label="Cidade" value={data?.city} />
          <DetailItem label="Estado" value={data?.state} />
          <DetailItem label="Estado" value={data?.state} />
          <DetailItem label="País" value={data?.country} />
          <DetailItem label="Latitude" value={data?.latitude} />
          <DetailItem label="Longitude" value={data?.longitude} />
        </Flex>
        <Flex
          p={4}
          gap={2}
          bg="bgContent"
          w="full"
          borderBottom={'1px solid'}
          borderColor="borderColor"
          flexDir={'column'}
        >
          <Text variant={'secondary'}>{data.owners.length} Moradores</Text>
          {data.owners.map((item: any) => (
            <OwnerCard key={item.id} owner={item} />
          ))}
        </Flex>
      </DrawerBody>
    </>
  )
}

const DetailItem = ({ label, value }: { label: string; value: string }) => {
  return (
    <Flex w="full" gap={2}>
      <Flex w="30%" justifyContent={'end'}>
        <Text variant={'secondary'} fontSize={'xs'} textAlign={'right'}>
          {label}
        </Text>
      </Flex>
      <Flex w="full">
        <Text fontSize={'xs'}>{value}</Text>
      </Flex>
    </Flex>
  )
}

const OwnerCard = ({ owner }: any) => {
  const goToCitizenProfile = useMemo(() => {
    return CITIZEN_PROFILE_EXTERNAL_ROUTES.CITIZEN_PROFILE.replace(
      '[citizenSlug]',
      owner?.unified_person_slug as string
    )
  }, [])

  return (
    <Flex
      border="1px solid"
      borderColor={'borderColor'}
      bg="bgContent"
      rounded={'md'}
      gap={4}
      alignItems={'center'}
      py={1}
      px={2}
    >
      <Flex border="2px solid" borderColor={'primary'} rounded={'full'} h="fit-content">
        {owner?.unified_person_main_avatar_url ? (
          <Avatar size={'sm'} src={owner?.unified_person_main_avatar_url} />
        ) : (
          <Avatar size={'sm'} name={owner?.unified_person_name} bg="lightPrimary" color="black" />
        )}
      </Flex>
      <Flex flexDir={'column'} gap={2} justifyContent={'space-around'} w="full">
        <Link href={goToCitizenProfile} target="_blank" w="100%">
          <Text fontSize={'md'} color="primary" textDecor={'underline'}>
            {owner?.unified_person_name}
          </Text>
        </Link>
        <Flex gap={2} alignItems={'center'} justifyContent={'space-between'} w="full">
          <Text fontSize={'sm'} variant={'secondary'}>
            {cpfMask(owner.unified_person_cpf_number)}
          </Text>
          <Badge>{owner.name}</Badge>
        </Flex>
      </Flex>
    </Flex>
  )
}

/* 

  <Flex p={4} gap={4} bg="bgContent" w="full" borderBottom={'1px solid'} borderColor="borderColor">
            <Flex border="2px solid" borderColor={'primary'} rounded={'full'}>
              <Avatar
                size={'xl'}
                src="https://impacto-prd-impacto-publicfiles-protected.s3.sa-east-1.amazonaws.com/public//person/1000000003/public-file/avatar/ATAFE7v0kmN3EsrwOz83LIl2mTLjk.avatar"
              />
            </Flex>
            <Flex flexDir={'column'} justifyContent={'space-around'}>
              <Text fontSize={'xl'}>Arthur de Melo Gerônimo</Text>
              <Link href={goToCitizenProfile} target="_blank" w="100%">
                <Button tabIndex={-1} w="100%">
                  Acessar perfil integrado
                </Button>
              </Link>
            </Flex>
          </Flex>

*/
